import { Checkbox, Form, FormItemProps } from "antd";
import { CheckboxGroupProps } from "antd/lib/checkbox";

interface Props extends Omit<CheckboxGroupProps, "name"> {
  readonly?: boolean;
  label?: React.ReactNode;
  groupClassName?: string;
  rules?: FormItemProps["rules"];
  groupProps?: FormItemProps;
  name?: string | (string | number)[];
}

const CustomCheckbox = (props: Props) => {
  const {
    className,
    groupClassName,
    label,
    name,
    rules,
    groupProps,
    readonly,
    ...listProps
  } = props;

  return (
    <Form.Item
      name={name}
      rules={rules}
      label={label}
      labelCol={{ span: 6 }}
      labelAlign="left"
      {...groupProps}
    >
      <Checkbox.Group {...listProps} disabled={readonly} />
    </Form.Item>
  );
};

export default CustomCheckbox;
